const ROMAN = ['0', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X']

export function toRoman(value: number | string | null | undefined) {
	if (value == null || value === '') return ''
	const n = Number(value)
	return ROMAN[n] ?? String(value)
}

export function formatTier(tier: number | null | undefined) {
	if (tier == null) return ''
	return `Tier ${toRoman(tier)}`
}

export function formatXp(xp: number | null | undefined) {
	if (xp == null) return ''
	return `${xp} XP`
}

export function formatPurchases(
	rank: number,
	maxPurchase: number | null | undefined,
) {
	const plural = rank > 1 ? 's' : ''
	if (maxPurchase == null) return `${rank} achat${plural}`
	return `${rank}/${maxPurchase} achat${maxPurchase > 1 ? 's' : ''}`
}
